export default function StepDashboard({ session, onSignOut }) {
  const name = session.faceLoginResult
    ? `${session.faceLoginResult.firstName || ""} ${session.faceLoginResult.lastName || ""}`.trim()
    : session.email;

  const authMethod = session.faceLoginResult ? "Face Recognition" : "Password";

  return (
    <div className="step-card center">
      <div className="complete-icon">👤</div>
      <h1>Dashboard</h1>
      <p className="step-sub">You are successfully signed in.</p>

      <div className="summary-card" style={{ marginTop: "1.5rem" }}>
        <div className="summary-row">
          <span className="summary-label">Name</span>
          <span className="summary-value">{name || "—"}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Email</span>
          <span className="summary-value">{session.email}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Role</span>
          <span className="summary-value capitalize">{session.role || "—"}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Signed in via</span>
          <span className="summary-value success">{authMethod} ✓</span>
        </div>
        {session.faceLoginResult && (
          <div className="summary-row">
            <span className="summary-label">Face match</span>
            <span className="summary-value success">{session.faceLoginResult.similarity}%</span>
          </div>
        )}
        <div className="summary-row">
          <span className="summary-label">Status</span>
          <span className="summary-value success">Verified</span>
        </div>
      </div>

      <button
        className="btn-ghost"
        style={{ marginTop: "1.5rem", width: "100%" }}
        onClick={onSignOut}
      >
        Sign Out
      </button>
    </div>
  );
}
